import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Row, Col} from "react-bootstrap"

import { useGetUser, useGetExternalAccountsLinked } from "../../hooks/useOfProfile"
import { useGetUserPermission, useGetUserConnectionsPerMonth } from '../../hooks/useOfCharts'

import PermissionCard from "../../components/PermissionCard/PermissionCard";
import ProfileInfo from "../../components/Profile/ProfileInfo"
import ChartUserAccesesPerMonth from "../../components/Charts/User/AccessPerMonth"
import ProfileHeader from "../../components/Profile/ProfileHeader";
import AuthVerify from "../../components/AuthVerify";
import PropTypes from 'prop-types';
import { useGetJobPositionById } from "../../hooks/useOfClient";
import { isNullOrUndefined } from "../../common/Helpers";
import { authGetClient } from "../../actions/auth-action";

const Profile = (props) => {

    const { t } = useTranslation();
    const { user: currentAuth } = useSelector((state) => state.auth);
    const userClientId = authGetClient();
    const inputParam_UserName = props.location?.state?.userName ?? (currentAuth?.userName ?? null);

    const [user, setUser] = useState(null);
    useGetUser(inputParam_UserName, setUser);

    const isCurrentUser = (user !== null) ? inputParam_UserName === user.username : false;

    const [userPermissions, setUserPermissions] = useState(null);
    useGetUserPermission(inputParam_UserName, userPermissions, setUserPermissions);

    const [userExternalAccounts, setUserExternalAccounts] = useState(null);
    useGetExternalAccountsLinked(inputParam_UserName, setUserExternalAccounts);

    const [chartData, setChartData] = useState(null);        
    useGetUserConnectionsPerMonth(inputParam_UserName, chartData, setChartData);

    const [jobPosition, setJobPosition] = useState(null);
	useGetJobPositionById(!isNullOrUndefined(userClientId) ? userClientId : null, !isNullOrUndefined(user) ? user.job : null, jobPosition, setJobPosition);

    return (
        <>
        {
            user === null &&
            <AuthVerify currentToken={currentAuth} />
        }
        {
            user !== null &&
            <>
                <Row>
                    <Col sm={12} md={12} lg={12} xl={12}>
                        <ProfileHeader
                            user={user}
                            isCurrentUser={isCurrentUser}
                            showResetPassword={true}
                            showEditProfile={true}
                            showSystemConnections={true}
                            systemConnections={userExternalAccounts}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={12} lg={6} xl={4}>
                        <ProfileInfo
                            user={user}
                            jobPosition={jobPosition}
                        />
                    </Col>
                    <Col sm={12} md={12} lg={6} xl={8}>
                        <ChartUserAccesesPerMonth chartData={chartData} />
                    </Col>
                </Row>
                <Row>     
                    <h3>{t('data-lang-boxname-permissions')}</h3>
                    {
                        userPermissions?.map((item) => 
                        <Col className="mt-3" key={item.index}>
                            <Row className="justify-content-center">
                                <Col xl={12}>
                                    <PermissionCard objPermission={item} />
                                </Col>
                            </Row>
                        </Col>)
                    }
                    {
                        !userPermissions &&
                        <div style={{minHeight: "100px"}} className="align-items-center row">
                            <div className="col-md-12 text-center">{t('data-lang-lbl-chart-nodatafound')}</div>
                        </div>
                    }
                </Row>
            </>
        }
        </>
    );
};
Profile.propTypes = {
    location: PropTypes.object.isRequired,
};
export default Profile;
